import Vue from 'vue';
import VueRx from 'vue-rx';
import Ripple from 'vue-ripple-directive';

import psHttp, { psAxios } from '@patsnap/common-ps-http';

import { Container } from 'inversify';
import { containerKey } from '@/@core/vue-inversify-decorator';
import { getI18n } from '@/i18n';
import router, { configRouter } from './router';
import store from './store';
import App from './App.vue';

import {
    applyGloablMixin,
} from './@core/mixins/gloablMixin';

import {
    buildService,
    Symbols,
} from './inversify.config';

// import { mockContrainer } from './inversify.mock.config';

import {
    IS_DEBUG,
    IS_DEVELOPMENT,
    Environment,
} from '@/@core/environment';
// Global Components
import { initVXETableLocale } from './global-components';
import { UniSetting } from './@core/uniSetting';

// 3rd party plugins
// import '@/libs/toastification';
import '@/libs/sweet-alerts';
import '@/libs/vue-select';
// import '@/libs/tour';
import {
    RavenInsertMeta,
} from '@/libs/sentry';

import { registerModules } from './config';

// import dataV from '@jiaminghi/data-view';

import { configPermission } from './config/permission';

// Vue.use(dataV);

// Vue.use(VXETable);

// Vue.use(IconsPlugin);
window.zPREFACE = window.zPREFACE || {};
// BSV Plugin Registration

Vue.use(VueRx);
Vue.directive('ripple', Ripple);
applyGloablMixin(Vue);

// Composition API
// Vue.use(VueCompositionAPI);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css'); // For form-wizard

// import core styles
require('@core/scss/core.scss');

// import assets styles
require('@/assets/scss/style.scss');

// import vue-select styles
require('@core/scss/vue/libs/vue-select.scss');

// import vue-flatpicker styles
require('@core/scss/vue/libs/vue-flatpicker.scss');

Vue.config.productionTip = false;
Vue.config.devtools = IS_DEBUG || IS_DEVELOPMENT;

const uniSetting = new UniSetting();

uniSetting.Ready.then(async(uniSetting) => {
    const container = new Container({
        // 默认简单的服务都是单例的
        defaultScope: 'Singleton',
    });
    const {
        passportUrlBase,
        backofficeUrlBase,
        marketplaceUrlBase,
        workspaceUrlBase,
        analyticsUrlBase,
        openApiUrlBase,
        labUrlBase,
        toolUrlBase,
        cmsUrlBase,
    } = uniSetting;
    const i18n = await getI18n();
    buildService(container, {
        uniSetting,
        i18n,
        router,
        vue: Vue,
        httpClient: psHttp,
        psAxios,
        environment: {
            ...Environment,
            region: uniSetting.region,
        },
        passportUrlBase,
        backofficeUrlBase,
        marketplaceUrlBase,
        workspaceUrlBase,
        analyticsUrlBase,
        openApiUrlBase,
        labUrlBase,
        toolUrlBase,
        cmsUrlBase,
    });

    // mockContrainer(container);

    // 初始化结构异常处理
    const errorHandler = container.get(Symbols.ErrorHandlerService);
    errorHandler.start();

    // 初始化Feature
    const systemService = container.get(Symbols.SystemService);
    systemService.region$.subscribe(region => {
        if (region) {
            store.commit('appFeature/setRegion', region);
        }
    });

    const authService = container.get(Symbols.AuthService);
    // 初始化权限相关
    configPermission({
        Vue,
        store,
        systemService,
        authService,
    });

    // 初始化 VeeValidateExtend
    const veeValidateExtendService = container.get(Symbols.VeeValidateExtendService);
    veeValidateExtendService.init();

    // 配置路由
    configRouter({
        router,
        authService,
        $P: Vue.$P,
        systemService,
        miscApi: container.get(Symbols.MiscApi),
        environment: Environment,
        navgationService: container.get(Symbols.NavgationService),
    });

    // 加入各种大模块
    registerModules({
        container,
        router,
        i18n,
        boBaseUrl: `${backofficeUrlBase}`,
    });

    new Vue({
        router,
        store,
        i18n,
        provide: {
            [containerKey]: container,
        },
        render: h => h(App),
    }).$mount('#app');

    initVXETableLocale(i18n.locale)

    // i18n

    window.$container = container;
    window.$symboles = Symbols;
    window.rvTrack = (action, attribute, moduleName = 'BackOffice') => {
        if (RavenInsertMeta) {
            RavenInsertMeta(moduleName, action, attribute);
        }
    };
    if (IS_DEBUG) {
        systemService.reportSystemInfo();
    }
});
